import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import { catalogReducer as catalog } from 'catalog/reducers';
import { funnelReducer as funnels } from 'funnel/reducers';
import { tipReducer as tips } from 'tip/reducers';
import { memoReducer as memos } from 'memo/reducers';
import { messagingReducer as messaging } from 'messaging/reducers';
import { manipsReducer as manips } from 'saas/pco/interventions/manipulations/reducers';
import { caseReducer as siteCase } from 'saas/pco/cases/form/reducers';
import { planReducer as plan } from 'saas/pco/zones/plan/reducers';
import { aastPlanReducer as aastPlan } from 'saas/aast/zones/plan/reducers';
import { diffusionReducer as diffusion } from 'modules/diffusion/reducers';
import { newsReducer as news } from 'modules/news/reducers';
import { usersReducer as users } from 'modules/admin/reducers/user';

export const makeRootReducer = () => {
  return combineReducers({
    router,
    form,
    catalog,
    funnels,
    tips,
    memos,
    messaging,
    manips,
    siteCase,
    plan,
    diffusion,
    news,
    users,
    aastPlan,
  });
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/modules/common/reducers/index.js